import { render, staticRenderFns } from "./ErrorPageFormComponent.vue?vue&type=template&id=154ce8f7&scoped=true"
import script from "./ErrorPageFormComponent.vue?vue&type=script&lang=js"
export * from "./ErrorPageFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ce8f7",
  null
  
)

export default component.exports